module.exports = __webpack_public_path__ + "static/media/Hero_canada.bfab0a8c.png";